import { render, staticRenderFns } from "./invoices-list.vue?vue&type=template&id=1b110140&"
import script from "./invoices-list.vue?vue&type=script&lang=js&"
export * from "./invoices-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports